<template lang="html">
  <section class="upsell">
    <heading
      v-bind="{label, title, subtitle}"
      level="h2"
    />
    <div class="upsell__list">
      <Thumbnail v-for="(item, index) in upsells" :key="index" v-bind="item" />
    </div>
  </section>
</template>

<script>
import CollectionApiService from '@/data/collection/CollectionApiService'

import Heading from '@/components/heading/Heading.vue'
import Thumbnail from '@/components/partials/Thumbnail.vue'

export default {
  components: {
    Heading,
    Thumbnail,
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    extraServices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      upsells: []
    }
  },
  async mounted () {
    const services = []
    this.extraServices.forEach(async (service) => {
      const response = await CollectionApiService.show('extra-services', service.id)
      let items = {
        image: response.data.image,
        title: response.data.title,
        level: 'h3',
        subtitle: response.data.price,
        link: `/extra-services/${response.data.slug}`,
      }
      services.push(items)
    })
    if(services) {
      this.upsells = services
    }
  }
}
</script>

<style lang="scss">
.upsell {
  &__list {
    padding: $padding $padding 0;
  }
}

</style>
